import { Box, Text, Icon, Link, Flex, Heading, Skeleton, AspectRatio, HTMLChakraProps } from '@chakra-ui/react';
import Image from 'next/legacy/image';
import { FC } from 'react';

import LinkedInIcon from '@/assets/icons/ic-share-linkedin-circle.svg';

import { ITeamMember } from '@/components/ui/features/team/data';

export interface ITeamBlockCardProps {
  member: ITeamMember;
}

export const TeamMemberCard: FC<ITeamBlockCardProps> = ({ member }) => {
  const { name, title, imagePath, institution, linkedInLink } = member;

  return (
    <Flex
      textAlign="center"
      alignItems="center"
      p="4"
      flexDir="column"
      w="288px"
      boxSizing="border-box"
      _hover={{
        boxShadow: 'card2xl',
      }}
    >
      <Box w="240px" display="flex" justifyContent="center" borderRadius="full" overflow="hidden">
        <Image width="240" height="240" src={imagePath} alt={name} quality={100} />
      </Box>
      <Heading fontSize="3xl" mt="6">
        {name}
      </Heading>
      {title && (
        <Text fontSize="md" color="gray.800" mt="4">
          {title}
        </Text>
      )}
      {institution && (
        <Text fontSize="md" color="gray.400" mt="2">
          {institution}
        </Text>
      )}
      <Link target="_blank" rel="noopener noreferrer" href={linkedInLink} display="block" h="30px" mt="4">
        <Icon as={LinkedInIcon} w="30px" h="30px" lineHeight="30px" />
      </Link>
    </Flex>
  );
};

export const TeamMemberCardFallback: FC<HTMLChakraProps<'div'>> = (props) => {
  return (
    <Flex flexDir="column" backgroundColor="white" alignItems="center" p="4" {...props}>
      <AspectRatio w={60} ratio={1}>
        <Skeleton borderRadius="full" />
      </AspectRatio>
      <Skeleton w="100%" h={['2.3rem', null, 9]} mt="6" />
      <Skeleton w="100%" h={[6, null, '1rem']} mt="4" />
      <AspectRatio w={7} ratio={1} mt="4">
        <Skeleton borderRadius="full" />
      </AspectRatio>
    </Flex>
  );
};
